import { render, staticRenderFns } from "./btn-read-more.vue?vue&type=template&id=0a7b888b&scoped=true"
import script from "./btn-read-more.vue?vue&type=script&lang=js"
export * from "./btn-read-more.vue?vue&type=script&lang=js"
import style0 from "./btn-read-more.vue?vue&type=style&index=0&id=0a7b888b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b888b",
  null
  
)

export default component.exports